<template>
    <div class="sty-section" :class="bemFacets">
        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>

        <div class="grid--container">
            <div class="grid--row sty-section--articles">
                <article class="grid--col sty-section--article"
                        v-for="(dimensions, size) in iconsBySize"
                        :key="size">
                    <div class="grid--row sty-section--dimensions">
                        <div class="grid--col sty-section--dimension"
                                v-for="(icons, dimension) in dimensions"
                                :key="dimension">
                            <sty-header class="sty-section--font-header" :facets="['font-header']">
                                <h3 class="u-reset u-reset__sty" v-text="size"/>
                            </sty-header>
                            <ul class="u-reset grid--row sty-section--list">
                                <li class="grid--col sty-section--item">
                                    <span class="sty-section--subtitle">
                                        <b class="sty-section--subtitle-text" v-text="dimension"/>
                                    </span>
                                </li>
                                <li class="grid--col sty-section--item"
                                        v-for="icon in sortIconsByName(icons)"
                                        :key="icon.name">
                                    <h4 class="u-reset u-reset__sty sty-section--icon-title"
                                            :title="icon.name"
                                            v-text="icon.name"/>
                                    <button class="sty-section--icon">
                                        <ui-icon :style="iconSize(size, icon)" :size="size" :symbol="icon.name"/>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
    import StyHeader from 'framework/styleguide/header';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { getIcons, iconSize, sortIconsByName } from './helpers';


    export default {
        components: {
            UiIcon,
            StyHeader,
        },
        mixins: [
            bemMixin('sty-section'),
        ],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                iconsBySize: {},
                globals,
            };
        },
        methods: {
            sortIconsByName,
            iconSize,
        },
        mounted() {
            getIcons().then(icons => {
                this.iconsBySize = icons;
            });
        },
    };
</script>
